import React from 'react';

const Background: React.FC = () => {
  return (
    <div className="fixed inset-0 pointer-events-none">
      {/* Gradient mesh background */}
      <div className="gradient-mesh" />
      <div className="floating-particles">
        {[...Array(18)].map((_, i) => (
          <div key={i} className="particle" />
        ))}
      </div>
      <div className="glow-orb glow-orb-1" />
      <div className="glow-orb glow-orb-2" />
      
      {/* Gold gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-feelr-gold/10 to-transparent pointer-events-none" />
    </div>
  );
};

export default Background; 